<template>
    <v-row>
      <v-col cols="12">
          <sale-product-per-day-card> </sale-product-per-day-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import SaleProductPerDayCard from "@/components/report/SaleProductPerDayCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Sales Product Per Day",
    },
  
    components: {
        SaleProductPerDayCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>